import { gsap } from "gsap";

export default class GlobalCtaHandler {
	init() {
		gsap.utils.toArray('[data-id="global_cta"]').forEach((e) => {
			const background = e.lastElementChild;
			
			if (background) {
				const backgroundTop = background.firstElementChild;
				const backgroundBottom = background.lastElementChild;
				
				const previousSection = e.previousElementSibling;
				
				if (previousSection && backgroundTop) {
					const classList = Array.from(previousSection.classList);
					
					let bgClass = classList.find(className => className.startsWith('bg-'));
					
					if (!bgClass) {
						const firstChildDiv = previousSection.querySelector('div');
						if (firstChildDiv) {
							const childClassList = Array.from(firstChildDiv.classList);
							bgClass = childClassList.find(className => className.startsWith('bg-'));
						}
					}
					
					if (bgClass) {
						backgroundTop.classList.add(bgClass);
					}
				}
				
				// Handle the next section for backgroundBottom
				const nextSection = e.nextElementSibling;
				
				if (nextSection && backgroundBottom) {
					const classList = Array.from(nextSection.classList);
					
					let bgClass = classList.find(className => className.startsWith('bg-'));
					
					if (!bgClass) {
						const firstChildDiv = nextSection.querySelector('div');
						if (firstChildDiv) {
							const childClassList = Array.from(firstChildDiv.classList);
							bgClass = childClassList.find(className => className.startsWith('bg-'));
						}
					}
					
					if (bgClass) {
						backgroundBottom.classList.add(bgClass);
					}
				}
			}
		});
	}
}